import type { TranscriptBlockGetOneResponseDto } from '../../dto/transcript-block-get-one.response.dto.js';

export enum TranscriptInconsistencyLevel {
  Minor = 'minor',
  Severe = 'severe',
}

export enum TranscriptInconsistencyStatus {
  Complete = 'complete',
  Reprocessing = 'reprocessing',
  Invalidated = 'invalidated',
  Dismissed = 'dismissed',
}

export interface TranscriptInconsistencyGetOneResponseDto {
  id: string;
  transcriptId: string;
  transcriptSubfactId: string;
  summary: string | null;
  description: string;
  level: TranscriptInconsistencyLevel;
  status: TranscriptInconsistencyStatus;
  evidenceFactIds: string[];
  createdDate: Date;
  transcriptSubfact?: {
    id: string;
    transcriptId: string;
    content: string;
    referencedBlocks?: TranscriptBlockGetOneResponseDto[];
  };
}
